// extracted by mini-css-extract-plugin
export default {"box":"ModalStudyPeriod_box__IW9w5","attention":"ModalStudyPeriod_attention__p-kVn"};